import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AppStateService } from '../app-state/app-state.service';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GtmService {
  enableGtm = environment.local ? !['localhost', environment.local.domain].includes(window.location.hostname) : true;

  constructor(
    private router: Router,
    private appState: AppStateService,
  ) {
    /**
    * Log page transitions to GTM
    */
    if (this.enableGtm) {
      this.router.events.forEach(item => {

        if (item instanceof NavigationEnd) {
          const payload = {
            ...this.getPayload({
              event: 'pageLoad',
              url: item.url,
            })
          }

          this.pushDataLayer(payload);
        }
      });
    }
  }

  pushEvent(data: {
    event: string;
    [key: string]: string;
  }) {
    if (!this.enableGtm) { return };
    const payload = {
      ...this.getPayload({
        ...data
      })
    }
    this.pushDataLayer(payload);

  }

  /**
   * Construct a payload for GTM and enrich it with extra data passed as params
   */
  private getPayload(data: {
    event: string;
    [key: string]: string;
  }): Record<string, any> {
    const facility = this.appState.get('currentFacility');
    const resident = this.appState.get('currentResident');
    const currentUser = this.appState.get('currentUser')
    return {
      ...data,
      resident_id: resident ? resident.id : '',
      user_type: currentUser ? currentUser.userType : '',
      legacy_facility_id: facility ? facility.legacyFacilityId : '',
      facility_id: facility ? facility.id : '',
      facility_name: facility ? facility.name : '',
      apollo: true
    };

  }

  private pushDataLayer(payload: Record<string, unknown>) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  }
}
